<template>
  <div class = "predict">
    <div class="text" style="font-size: 18px;line-height: 25px;">
      Predict the nitric oxide (NO) production inhibition activity of a Natural Product
      Input natural products (this tool may not work well for synthetic compounds)
      The results will be given as the Probability of having an IC50 (inhibition of nitric oxide production in macrophages) &lt; 50 μM, while without cytotoxicity.
      For example:
    </div>

    <div class="">
      <el-form ref="ruleForm" :inline="true" :model="ruleForm" :rules="rules" label-width="130px" class="demo-ruleForm">
        <el-form-item label="Structure:" style="font-size: 18px;">
          <el-col :span="11">
            <el-input
              placeholder="O1[C@]2([C@@H]([C@@]3([C@H](C(CCC3)(C)C)CC2)C)C[C@H]1C1=CC(=O)O[C@H]1O)COC(=O)C
  CC(=O)O[C@@H]1[C@@H]([C@@H]2[C@](C=CC(=O)C2(C)C)([C@@H]3[C@@]1(C4=CC[C@H]([C@@]4(CC3)C)C5=COC=C5)C)C)O
  C[C@@]12CC[C@@H]3[C@]4(C=CC(=O)C([C@@H]4C[C@H]([C@]3(C1=CC(=O)[C@H]2C5=COC=C5)C)O)(C)C)C"
              type="textarea" style="width:1100px;font-size: 18px;" :autosize="{ minRows: 10, maxRows: 200 }" v-model="ruleForm.structure"></el-input>
          </el-col>
        </el-form-item>
        <div>
          <el-form-item label="Name:" >
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="E-mail:">
          <el-input v-model="ruleForm.mail"></el-input>
        </el-form-item>
        <el-form-item label="Job-Id:">
          <el-input v-model="ruleForm.job_id"></el-input>
        </el-form-item>
        </div>
        
        <div class="submit">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">Predict</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
export default {
  name: "predict",
  data() {
    return {
      ruleForm: {
        structure: "",
        name: "",
        mail: "",
        job_id: "",
      },
      rules: {
        name: [
          { required: true, message: "Please enter your name", trigger: "blur" },
        ],
        mail: [
          { required: true, message: "Please enter your mail", trigger: "blur" },
        ],
        job_id: [
          { required: true, message: "Please enter your job_id", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.login();
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    onSubmit() {
      if(!this.ruleForm.name ||!this.ruleForm.mail ||!this.ruleForm.job_id){
        this.$message({
          message: 'Please enter complete',
          type: 'warning'
        });
      } else{
        this.$http({
        url: "/api/predict/predictBySmiles",
        methods: "get",
        params: this.ruleForm,
      }).then((data) => {
        console.log(data);
        // this.$message('successfully');
        // // this.$router.back();
        this.$message({
          message: 'successfully',
          type: 'success'
        });
      });
      }
      
    },
  },
};
</script>

<style scoped>
  .predict{padding:0 100px;margin:0 auto;font-size: 18px;}
  .text {font-size: 25px;padding:10px 20px;margin:0 0 20px 0;background: #F5F7F9;border-radius:4px;color:#3B454E;text-indent:2em;font-size:18px;color:#3B454E;}
  .page-warp {margin-top:10px;display:flex;justify-content:center;}
  .down-load {display:flex;justify-content:flex-end;}
  .demo-table-expand {font-size:0;}
  .demo-table-expand label {width:90px;color:#99a9bf;}
  .demo-table-expand .el-form-item {margin-right:0;margin-bottom:0;width:50%;}
  

  .submit{margin:0 0 0 130px;}
</style>